import { ENV, Translations } from "./types";

type Selector = string | null;

export type Store = {
  setEmbeddedSelector: (selector: Selector) => void;
  getEmbeddedSelector: () => Selector;
  getEnvironment: () => ENV;
  getCheckoutUrl: () => string | undefined;
  setTranslations: (translations: Translations) => void;
  getTranslations: () => Translations | null;
};

export const createStore: (environment?: ENV, checkoutUrl?: string) => Store = (
  environment = "LIVE",
  checkoutUrl
) => {
  let embeddedSelector: Selector = null;
  let translations: Translations | null = null;

  const setEmbeddedSelector = (selector: Selector) => {
    embeddedSelector = selector;
  };

  const getEmbeddedSelector = () => {
    return embeddedSelector;
  };

  const getEnvironment = () => {
    return environment;
  };

  const getCheckoutUrl = () => {
    return checkoutUrl;
  };

  const setTranslations = (newTranslations: Translations) => {
    translations = newTranslations;
  };

  const getTranslations = () => {
    return translations;
  };

  return {
    setEmbeddedSelector,
    getEmbeddedSelector,
    getEnvironment,
    getCheckoutUrl,
    setTranslations,
    getTranslations,
  };
};
